const CheckboxUnCheckSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <rect x="1.5" y="1.5" width="13" height="13" rx="3.5" stroke="#D5D5D5" />
    </svg>
  );
};

export default CheckboxUnCheckSvg;
